import React from "react";
import _ from "lodash";
import jquery from "jquery";

import VisibilitySensor from "react-visibility-sensor";

import InfiniteScrollArticle from "./infinite_scroll/InfiniteScrollArticle.js";

class InfiniteScroll extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      articles: [],
      isLoading: false
    };

    this.originalPermalink = window.location.pathname;
    this.nextPostIds = window.nextPostIds;

    // This binding is necessary to make `this` work in the callback
    this.loadNextArticle = this.loadNextArticle.bind(this);

    this.setOriginalArticle = this.setOriginalArticle.bind(this);
    this.setOriginalArticleThrotteld = _.throttle(
      this.setOriginalArticle,
      1000
    );
    window.addEventListener("scroll", this.setOriginalArticleThrotteld);

    this.below_the_fold_ad_switched = false;
  }

  componentDidMount() {
    /* console.log("componentDidMount");*/
  }

  componentWillUnmount() {
    /* console.log("componentWillUnmount");*/
  }

  setOriginalArticle() {
    /* console.log("setOriginalArticle"); */

    if (this.refs.article_scroll_container) {
      var rect = this.refs.article_scroll_container.getBoundingClientRect();

      if (
        rect.top > window.innerHeight &&
        window.location.pathname !== this.originalPermalink
      ) {
        /* console.log("setting original permalink"); */
        history.pushState(null, null, this.originalPermalink);
      }
    } else {
      console.log("DEBUG: no ref article_scroll_container??");
    }
  }

  loadNextArticle(isVisible) {
    console.log("loadNextArticle", isVisible);

    if (!isVisible) {
      return;
    }

    if (this.state.isLoading) {
      return;
    }

    var currentIndex = this.state.articles.length;
    var nextPostId = this.nextPostIds[currentIndex];

    var currentIndex = this.state.articles.length;
    var nextPostId = this.nextPostIds[currentIndex];

    if (currentIndex == 10) {
      return;
    }

    if (!nextPostId) {
      return;
    }

    this.setState(function(prevState, props) {
      window.is_infinite_scroll_loading = true;
      return {
        isLoading: true,
        articles: prevState.articles
      };
    });

    var url = "/posts/get_post/" + nextPostId;

    jquery.get(url).then(response => {
      console.log("received new post data");

      /* debugger;*/

      this.setState(function(prevState, props) {
        prevState.articles.push(response);

        window.is_infinite_scroll_loading = false;

        return {
          articles: prevState.articles,
          isLoading: false
        };
      });

      this.nextArticleLoadedHook();
    });
  }

  nextArticleLoadedHook() {
    console.log("nextArticleLoadedHook");
    this.refreshStickyAd();
  }

  refreshStickyAd() {
    console.log("AD DEBUG: refreshStickyAd");

    if (this.props.isMobile) {
      var ad_slot = window.ad_slots[window.mobile_bottom_ad_id];
    } else {
      var ad_slot = window.ad_slots[window.sticky_above_latest_ad_id];
    }

    if (ad_slot) {
      if (window.is_client_or_event_ad) {
        console.log("AD DEBUG: refreshStickyAd, isClient");
        googletag.pubads().refresh([ad_slot]);
        return;
      }

      console.log("AD Debug: refreshing GPT tag, done");

      if (!this.below_the_fold_ad_switched) {
        if (this.props.isMobile) {
          this.swapGptAdUnit(
            window.mobile_bottom_ad_id,
            "div-mobile-bottom-below-the-fold-ad"
          );
        } else {
          this.swapGptAdUnit(
            window.sticky_above_latest_ad_id,
            "div-sticky-below-the-fold-ad"
          );
        }
      } else {
        /* debugger; */
        googletag.pubads().refresh([ad_slot]);
      }
    }
  }

  swapGptAdUnit(fromId, toId) {
    console.log("AD Debug: swapGptAdUnit: ", fromId, toId);
    var ad_slot = jquery("#" + fromId);
    ad_slot.empty();
    ad_slot.removeAttr("data-google-query-id");
    ad_slot.attr("id", toId);

    // After rename, the original CSS selector no longer applies — set explicit
    // dimensions so GPT's IntersectionObserver sees a non-zero container height.
    if (this.props.isMobile) {
      ad_slot.css({ 'height': '50px', 'width': '320px' });
    } else {
      ad_slot.css({ 'min-height': '600px', 'width': '300px' });
    }

    var slotName;
    if (this.props.isMobile) {
      slotName = "fader_v3_mobile2_320x50";
      var size = [320, 50];
    } else {
      slotName = "fader_v3_article_sticky_below_the_fold_300x250";
      var size = [[300, 250], [300, 600]];
    }

    var $this = this;

    window.requestAnimationFrame(function() {
      googletag.cmd.push(function() {
        var divID = toId;

        var slot = googletag
          .defineSlot("/1081121/" + slotName, size, divID)
          .addService(googletag.pubads());

        googletag.display(divID);

        if ($this.props.isMobile) {
          window.mobile_bottom_ad_id = toId;
          window.ad_slots[window.mobile_bottom_ad_id] = slot;
        } else {
          window.sticky_above_latest_ad_id = toId;
          window.ad_slots[window.sticky_above_latest_ad_id] = slot;
        }
      });
    });

    this.below_the_fold_ad_switched = true;
  }

  render() {
    let loading_class = "";
    if (!this.props.isMobile) {
      loading_class = "two_thirds";
    }

    let loadingIcon = <div>&nbsp;</div>;

    if (this.state.isLoading) {
      loadingIcon = (
        <div className={loading_class}>
          <div className="loading_icon" />
        </div>
      );
    }

    var index = -1;
    var articles = this.state.articles.map(article => {
      index += 1;
      return (
        <InfiniteScrollArticle
          key={index}
          html={article.html}
          permalink={article.permalink}
          index={index}
          isMobile={this.props.isMobile}
          originalPermalink={this.originalPermalink}
          title={article.title}
          sections={article.sections}
          author={article.author}
          vertical={article.vertical}
          category={article.category}
          article_type={article.article_type}
        />
      );
    });

    return (
      <div ref="article_scroll_container">
        <div>{articles}</div>

        <VisibilitySensor
          onChange={this.loadNextArticle}
          delay={10}
          partial={true}
        >
          {loadingIcon}
        </VisibilitySensor>
      </div>
    );
  }
}

export default InfiniteScroll;

/* InfiniteScroll.propTypes = {
 *   isMobile: React.PropTypes.bool
 * }; */
